import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import ACL_RELATIONSHIPS from "acl-relationships";
import { Button } from "@/components/ui/button";
import Authorized from "components/Authorized";
import { getNextQueryParams } from "components/helpers";
import useAuthorized from "hooks/useAuthorized";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import EmailFooterService from "services/EmailFooters";
import {
  invalidateEmailFooterTableQuery,
  useEmailFooterTable,
} from "hooks/useEmailFooterTable";

export const EMAIL_FOOTER_TABLE_CONSTANTS = {
  tableName: "email_footers",
  queryKey: "email_footers",
  className: "EmailFooter",
  header: "Email Footers",
  headerIcon: "mail outline",
};

const EmailFooterTableV3 = () => {
  const navigate = useNavigate();
  const enableTags = useAuthorized(
    [
      ACL_RELATIONSHIPS.emailFootersTags.create,
      ACL_RELATIONSHIPS.emailFootersTags.read,
      ACL_RELATIONSHIPS.emailFootersTags.delete,
    ],
    { partialMatch: true }
  );
  const { filters, columns } = useEmailFooterTable({
    className: EMAIL_FOOTER_TABLE_CONSTANTS.className,
    tableName: EMAIL_FOOTER_TABLE_CONSTANTS.tableName,
  });

  const fetchEmailFooters = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await EmailFooterService.getEmailFooters(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching email footers:", error);
        throw error;
      }
    },
    [columns]
  );

  const createButton = (
    <Authorized permissions={[ACL_RELATIONSHIPS.emailFooters.create]}>
      <Button
        size="sm"
        className="item-adder"
        onClick={() => navigate("/settings/email_footers/new")}
      >
        New Footer Template
      </Button>
    </Authorized>
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={EMAIL_FOOTER_TABLE_CONSTANTS.headerIcon}
      header={EMAIL_FOOTER_TABLE_CONSTANTS.header}
      tableName={EMAIL_FOOTER_TABLE_CONSTANTS.tableName}
      queryKey={EMAIL_FOOTER_TABLE_CONSTANTS.queryKey}
      className={EMAIL_FOOTER_TABLE_CONSTANTS.className}
      fetchData={fetchEmailFooters}
      createButton={createButton}
      enableSearch
      enableSettings
      tagsDropdownParams={{ visible: enableTags }}
      invalidateData={invalidateEmailFooterTableQuery}
    />
  );
};

export default EmailFooterTableV3;
